
export enum EventDisciplineMts { //!same as keys in categoryIconMap
    None = 0,
    Hockey = 834,
    Tennis = 836,
    Football = 831,
    Basketball = 830,
    Volleyball = 837,
    Handball = 833,
    Netbal = 881,
    Futsal = 854,
    Baseball = 829,
    AmFootball = 839,
    Badminton = 841,
    Snooker = 861,
    Rugby = 859,
    TableTennis = 865,
    Darts = 849
}

export enum LiveEventStatus {
    Created = 1,
    Opened = 2,
    Suspended = 3,
    Closed = 4
}

export interface IEventDisciplineWrapper {
    isFootball(graphicsPresentationId: number): boolean;
    isBaseball(graphicsPresentationId: number): boolean;
    isAmFootball(graphicsPresentationId: number): boolean;
    isTennis(graphicsPresentationId: number): boolean;
    isHockey(graphicsPresentationId: number): boolean;
}

export const eventDisciplineWrapper: IEventDisciplineWrapper = {
    isFootball: (graphicsPresentationId: number) => {
        return graphicsPresentationId === 831;
    },
    isBaseball: (graphicsPresentationId: number) => {
        return graphicsPresentationId === 829;
    },
    isAmFootball: (graphicsPresentationId: number) => {
        return graphicsPresentationId === 839;
    },
    isTennis: (graphicsPresentationId: number) => {
        return graphicsPresentationId === 836;
    },
    isHockey: (graphicsPresentationId: number) => {
        return graphicsPresentationId === 834;
    }
}